import { ListItem } from "./ListItem";

export default class Segment {
    private static segments: ISegment[] = require("../data/Segment.json");

    static academic = new Segment("Academic");
    static professional = new Segment("Professional");
    static reseller = new Segment("Reseller");
    static higherEd = new Segment("HigherEd");
    static secondaryEd = new Segment("SecondaryEd");
    static items: ListItem[] = [];

    static initialize() {
        // Determine default values for all segments
        Segment.items = Segment.segments
            .filter(s => new Segment(s.code).childSegments.length === 0)
            .map(s => ({ value: s.code, name: s.name } as ListItem))
            .sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
    }

    private find(code?: string): ISegment|undefined {
        return Segment.segments.find(s => s.code === code || s.name === code);
    }

    constructor(code: string) {
        this._segment = this.find(code);
    }

    private _segment?: ISegment;

    get code(): string {
        return this._segment ? this._segment.code : "";
    }

    get name(): string {
        return this._segment ? this._segment.name : "";
    }

    get defaultSegmentCode(): string {
        for (var segment = this._segment; segment; segment = this.find(segment.parentSegmentCode))
            if (segment.defaultSegmentCode) return segment.defaultSegmentCode;
        return "PRO-USER";
    }

    get defaultPriceGroupId(): number {
        for (var segment = this._segment; segment; segment = this.find(segment.parentSegmentCode))
            if (segment.defaultPriceGroupId) return segment.defaultPriceGroupId;
        return 0;
    }

    get defaultPriceId(): number {
        for (var segment = this._segment; segment; segment = this.find(segment.parentSegmentCode))
            if (segment.defaultPriceId) return segment.defaultPriceId;
        return 15;
    }

    get rootSegment(): Segment {
        let segment: Segment = this;
        while (segment.parentSegment)
            segment = segment.parentSegment;
        return segment;
    }

    get parentSegment(): Segment|undefined {
        return this._segment && this._segment.parentSegmentCode ? new Segment(this._segment.parentSegmentCode) : undefined;
    }

    get childSegments(): Segment[] {
        return Segment.segments.filter(s => s.parentSegmentCode === (this._segment ? this._segment.code : "")).map(s => new Segment(s.code));
    }

    get isRoot(): boolean {
        return !this.parentSegment;
    }
}

Segment.initialize();

interface ISegment {
    code: string;
    name: string;
    defaultSegmentCode?: string;
    defaultPriceGroupId?: number;
    defaultPriceId?: number;
    parentSegmentCode?: string;
}
